module.exports = __webpack_public_path__ + "static/ss1.0f7b1a47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss1.png
// module id = 1186
// module chunks = 81679748166845